import React, { useEffect, useState } from "react";
import { Col, Row, Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import ListView from "../../../../shared/components/listview/ListView";
import Permissions from "../../../../shared/components/Permissions";
import DefaultButton from "../../../../shared/components/DefaultButton";
import Modalpopup from "../../../../shared/components/Modalpopup";
import { loadPTDataRequest, loadPTDeleteDataRequest } from "../../productTables/redux/Actions";
import PTAdd from "../../productTables/components/PTAdd";
import PTEdit from "../../productTables/components/PTEdit";
import DeleteModal from "../../../../shared/components/DeleteModal";

const ServiceType = ({ data }) => {
  let dispatch = useDispatch();
  let navigate = useNavigate();

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  let { productTables } = useSelector((state) => state.productTables);

  let [selectedRow, setSelectedRow] = useState({});
  const [shouldReload, setShouldReload] = useState(true);

  let emp_no = JSON.parse(localStorage.getItem("emp_no"));
  let module_name = "Product Tables";
  let permission = Permissions(emp_no, module_name);

  let actionsPermission = !(
    permission.write_permission || permission.delete_permission
  );

  const columns = [
    {
      display_name: "id",
      field: "id",
      type: "number",
      hide: true,
    },
    {
      display_name: "Service Type Name",
      field: "name",
      type: "text",
    },
    {
      display_name: "",
      field: "actions",
      type: "actions",
      hide: actionsPermission,
    },
  ];

  let [clickEditFunc, setClickEditFunc] = useState(null);
  let [clickDeleteFunc, setClickDeleteFunc] = useState(null);
  useEffect(() => {
    if (permission.write_permission) {
      setClickEditFunc(() => (row) => {
        setSelectedRow(row);
        setShowEditModal(true);
      });
    }
    if (permission.delete_permission) {
      setClickDeleteFunc(() => (id) => {
        setSelectedRow(id);
        setShowDeleteModal(true);
      });
    }
  }, [permission]);

  const handleDelete = () => {
    dispatch(loadPTDeleteDataRequest({ id: [selectedRow] })) 
    setShouldReload(true);
    setShowDeleteModal(false);
  };

  if (data === null) {
    data = productTables?.accountTypeData;
  }

  return (
    <>
      <div className="createNewBtn">
        <DefaultButton
          buttonClass={"default-btn-color"}
          buttonTitle={"Create New"}
          actionBlock={() => setShowCreateModal(true)}
        />
      </div>
      <Row>
        <Card>
          <Card.Body>
            <ListView
              columnNames={columns}
              rowData={data}
              clickEdit={clickEditFunc}
              clickDelete={clickDeleteFunc}
            />
          </Card.Body>
        </Card>
      </Row>
      <Modalpopup
        show={showCreateModal}
        handleClose={() => setShowCreateModal(false)}
        actionTitle={"Create Service Type"}
      >
        <PTAdd
          name={true}
          description={false}
          formName={'/product/service_type/'}
          handleClose={(reload) => {
            setShowCreateModal(false);
            if (reload) {
              dispatch(loadPTDataRequest()); 
            }
          }}
        />
      </Modalpopup>
      <Modalpopup
        show={showEditModal}
        handleClose={() => {
          setShowEditModal(false);
        }}
        actionTitle={"Edit Service Type"}
      >
        <PTEdit
          name={true}
          description={false}
          formName={'/product/service_type/' + selectedRow?.id}
          ptData={selectedRow}
          handleClose={(reload) => {
            if (reload) {
              dispatch(loadPTDataRequest());
            }
            setShowEditModal(false);
          }}
        />
      </Modalpopup> 
      <DeleteModal
        handleClose={() => {
          setShowDeleteModal(false);
        }}
        handleDelete={handleDelete}
        show={showDeleteModal}
      >
        <div>Delete Service Type?</div>
      </DeleteModal> 
    </>
  );
};

export default ServiceType;
